const baseConfig = {
	baseURL: process.env.REACT_APP_API_URL,
	api_user: process.env.REACT_APP_API_USER,
	api_password: process.env.REACT_APP_API_PASSWORD,
	send_events_to_analytics: process.env.REACT_APP_SEND_TO_ANALYTICS
};

export { baseConfig };
